import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTraffic } from "store/wheel/selectors";
import styled from "styled-components";
import { Cancel } from '@mui/icons-material';
import { revokeTrafficModal } from "store/wheel/actions";
import { useDispatch } from "react-redux";
import { find, get } from "lodash";
import ResizeAndDragabble from "./ResizeAndDraggable";
import { useCurrentUser } from "store/users/selectors";
import AccordinButton from "./AccordinButton";
import StoryWithImages from "./StoryWithAi/StoryView";
import Loading from "components/Loading";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  z-index: 99999999;
  pointer-events: none;
  
  .mainCheckList {
    pointer-events: auto;
  }
`;

const StoryContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

const WidgetsAssignmentStory = ({ currentClass, onClose: onCloseCallback }) => {
  const [showAccordin, setShowAccordin] = useState(true);
  const [trafficModal] = useTraffic();
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const isTeacher = get(currentUser, "role") === "teacher";
  const trafficData = trafficModal?.widget_menu ?? [];
  const filterByWidget = find(
    trafficData,
    (item) => item?.menu === "assignment_story"
  );
  const storyData = filterByWidget?.data?.storyData || null;
  const imageRef = useRef(null);
  const imageConfigurationRef = useRef(null);

  const getDefaultDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const minMargin = 20;
    let widgetWidth = 500;
    let widgetHeight = 600;

    if (width < 520) {
      widgetWidth = Math.max(400, width - minMargin * 2);
      widgetHeight = Math.max(400, height - minMargin * 2);
    } else if (width < 768) {
      widgetWidth = Math.max(400, Math.min(width - minMargin * 2, 500));
      widgetHeight = Math.max(400, Math.min(height - minMargin * 2, 600));
    }

    const x = Math.max(minMargin, (width - widgetWidth) / 2);
    const y = Math.max(minMargin, (height - widgetHeight) / 2);

    return {
      x: Math.min(x, width - widgetWidth - minMargin),
      y: Math.min(y, height - widgetHeight - minMargin),
      width: widgetWidth,
      height: widgetHeight,
    };
  };

  const getMinWidth = () => {
    const width = window.innerWidth;
    if (width < 768) {
      return 270;
    }
    return 500;
  };

  const getMinHeight = () => {
    const width = window.innerWidth;
    if (width < 768) {
      return 300;
    }
    return 500;
  };

  const [defaultDimensions] = useState(getDefaultDimensions());
  const [dimensions, setDimensions] = useState({ 
    width: defaultDimensions.width, 
    height: defaultDimensions.height 
  });

  useEffect(() => {
    if (imageConfigurationRef.current) {
      imageConfigurationRef.current = {
        clientHeight: imageConfigurationRef.current.clientHeight
      };
    }
  }, [dimensions, showAccordin]);

  const onClose = async () => {
    await dispatch(revokeTrafficModal(filterByWidget?.id));
    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  const handleTouchClose = (event) => {
    event.preventDefault();
    onClose();
  };

  if (!filterByWidget?.view || filterByWidget?.menu !== "assignment_story") {
    return null;
  }

  return createPortal(
    <Container className="allCheckListSEction wigetsContainer">
      <div className="mainCheckList">
        <ResizeAndDragabble 
          minWidth={getMinWidth()}
          minHeight={getMinHeight()}
          aspectRatio={false}
          resize={(data) => setDimensions(data)}
          page={"assignment_story"}
          showAccordin={showAccordin}
          center={true}
        >
          <div
            className="checkListTopSection widgetSpcBtm"
            style={{
              position: "relative",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
              height: showAccordin ? "100%" : "0px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              placeItems: "center",
              padding: "0px"
            }}
          >
            <div
              className={`checkListFirstTxt widgetFooterGradientOrange w-full bg-blue-10 pt-17px pb-14px ${
                showAccordin ? "br-topLeft-topRight-20px" : "br-15px"
              } `}
            >
              <AccordinButton
                open={showAccordin}
                onClose={() => setShowAccordin((prev) => !prev)}
              />

              <span className="text-white text-ft12-700">Story</span>
            </div>

            <Cancel
              onClick={() => onClose()}
              onTouchStart={handleTouchClose}
              style={{
                marginLeft: "5px",
                position: "absolute",
                right: 7,
                top: 16,
                fontSize: 18,
                color: "red",
                background: "white",
                borderRadius: 20,
                cursor: "pointer"
              }}
            />
            {showAccordin && (
              <StoryContentWrapper ref={imageConfigurationRef} data-no-drag>
                {storyData ? (
                  <StoryWithImages data-no-drag={true}
                    imageConfiguration={imageConfigurationRef.current}
                    ref={imageRef}
                    images={storyData?.images || []}
                    text={storyData?.story_content || ''}
                    title={storyData?.story_title || ''}
                    storyInfo={storyData}
                    is_student={true}
                    isStream={false}
                    enable_student_share={false}
                    isLevel={false}
                    isStory={true}
                  />
                ) : (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%',
                    color: 'white',
                    padding: '20px',
                    textAlign: 'center'
                  }}>
                    <Loading size={40} white={true} />
                  </div>
                )}
              </StoryContentWrapper>
            )}

            {showAccordin && (
              <div className="widgetFooter widgetFooterGradientOrange"><label>Widget</label></div>
            )}
          </div>

        </ResizeAndDragabble>

      </div>
    </Container>,
    document.body
  );
};

export default WidgetsAssignmentStory;
